module.exports = __webpack_public_path__ + "static/media/durga_puja_banner.8b2524f7.jpeg";